module.exports = __webpack_public_path__ + "img/CDK22.2bb86489.png";